import { observer } from "mobx-react-lite";
import { GetPremiumCTA } from "components/PremiumCTA/GetPremiumCTA";
import { useEffect } from "react";

import './ModuleLibrary.scss';
import { ModuleCard } from "components/ModuleCard/ModuleCard";
import { useStores } from "index";

export const ModuleLibrary = observer(() => {
  return (
    <div className="modules-tab">
      <GetPremiumCTA />
      <ModulesGrid />
    </div>
  )
});

const ModulesGrid = observer(() => {

  const { modules, isLoading } = useModules();

  if (isLoading) {
    return <div className="modules-grid">Loading modules...</div>;
  }

  return (
    <div className="modules-grid">
      {modules.map((module) => (<ModuleCard key={module.id} module={module} />))}
    </div>
  );
});

  const useModules = () => {
    const { modulesStore } = useStores();

    useEffect(() => {
      modulesStore.getModules();
    }, [modulesStore]);

    return {
      modules: modulesStore.modules,
      isLoading: modulesStore.isLoading
    }
  }